export default "__VITE_ASSET__DmHE9UCa__"